import { courseOne, courseEditedTwo, herbalWalkGroup } from '@/assets/siteMedia'

export const offerings = [
  {
    title: 'Courses & Workshops',
    text: 'Practical group learning in herbal medicine, holistic health, and traditional healing knowledge.',
    image: courseEditedTwo,
  },
  {
    title: 'Herbal Walks',
    text: 'Guided outdoor learning that helps participants identify and understand local medicinal plants.',
    image: herbalWalkGroup,
  },
  {
    title: 'Community Education',
    text: 'Tailored talks and programmes for organisations, schools, festivals, and community groups.',
    image: courseOne,
  },
]
